import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from './app.reducer';

const selectAppState = createFeatureSelector<AppState>('mainState');

export const categoriesSelector = createSelector(
    selectAppState,
    (state) => Object.entries(state.tableDetails).reduce((acc, [name, details])=> {
        const detail = {
            name: name,
            length: details.reduce((acc, val)=> acc+val.length,0)
        }
        return [...acc, detail]
    }, [] as { name: string; length: number; }[]) || []
)

export const activeCategorySelector = createSelector(
    selectAppState,
    (state) => state.activeCategory
)

export const subCategoriesSelector = createSelector(
    selectAppState,
    activeCategorySelector,
    (state, name) => state.tableDetails[name] || []
)

export const activeSubCategorySelector = createSelector(
    selectAppState, activeCategorySelector,
    (state, name) => (state.tableDetails[name] || []).find(({label})=> label == state.activeSubCategory)
)